import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { useNav } from "@/utils/nav";
import { faces, painFaces } from "@patient-watch/icons";
import { ui } from "@patient-watch/ui";
import { createFileRoute } from "@tanstack/react-router";
import type { ComponentType } from "react";

export const Route = createFileRoute("/_app/design/icons/faces")({
    component: FaceIconsDemo,
});

const RATING_FACES = Object.entries(faces).sort(([left], [right]) => left.localeCompare(right)) as [
    string,
    ComponentType,
][];

const PAIN_FACES = Object.entries(painFaces).sort(([left], [right]) => left.localeCompare(right)) as [
    string,
    ComponentType,
][];

function IconGrid({ items }: { items: [string, ComponentType][] }) {
    return (
        <div className="gap-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4">
            {items.map(([name, Icon]) => (
                <ui.Card key={name}>
                    <ui.CardContent className="flex flex-col items-center gap-4 p-6">
                        <div className="flex justify-center items-center w-20 h-20">
                            <Icon />
                        </div>
                        <p className="font-mono text-sm text-center">{name}</p>
                    </ui.CardContent>
                </ui.Card>
            ))}
        </div>
    );
}

function FaceIconsDemo() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Icons", route: { to: "/design/icons" } },
        { label: "Faces", route: { to: "/design/icons/faces" } },
    ]);

    return (
        <AdminPageLayout
            title="Face icons"
            description="Numeric rating faces and pain scale faces from @patient-watch/icons."
            maxWidthClassName="max-w-5xl"
        >
            <div className="space-y-10">
                <section>
                    <h2 className="mb-2 font-semibold text-lg">Rating faces (0-10)</h2>
                    <p className="mb-4 text-muted-foreground text-sm">Used for numeric pain and outcome scales.</p>
                    <IconGrid items={RATING_FACES} />
                </section>
                <section>
                    <h2 className="mb-2 font-semibold text-lg">Pain faces</h2>
                    <p className="mb-4 text-muted-foreground text-sm">
                        Verbal pain descriptors on visual analogue scales.
                    </p>
                    <IconGrid items={PAIN_FACES} />
                </section>
            </div>
        </AdminPageLayout>
    );
}
